export default "__VITE_ASSET__dThB6k5B__"